'use client';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { NavLinks } from './navbarItens';

const siteDisplayName = process.env.NEXT_PUBLIC_SITE_NAME || 'TV Foco';
const logoWidth = Number(process.env.NEXT_PUBLIC_SITE_LOGO_WIDTH) || 160;
const logoHeight = Number(process.env.NEXT_PUBLIC_SITE_LOGO_HEIGHT) || 60;
const logoAriaAndAlt = `Logo ${siteDisplayName}`;
const logoSrc = '/logo-white.svg';

function LogoLink() {
	return (
		<a
			href="/"
			className="logo"
			aria-label={logoAriaAndAlt}
			style={{
				display: 'block',
				width: logoWidth,
				minWidth: logoWidth,
				height: logoHeight,
				position: 'relative',
				flexShrink: 0,
			}}
		>
			{/* img nativo: evita falhas intermitentes do /_next/image */}
			<img
				src={logoSrc}
				width={logoWidth}
				height={logoHeight}
				alt={logoAriaAndAlt}
				decoding="async"
				fetchPriority="low"
				style={{ width: logoWidth, height: logoHeight, objectFit: 'contain' }}
			/>
		</a>
	);
}

const Navbar = () => {
	
	const [openMenuToggled, toggleMenu] = useState(false);
	const rafCloseRef = useRef(null);
	const closeMenu = useCallback(() => {
		toggleMenu((prev) => (prev ? false : prev));
	}, []);
	const handleClickMenu = useCallback(() => {
		toggleMenu((prev) => !prev);
	}, []);

	useEffect(() => {
		if (typeof window === 'undefined' || !openMenuToggled) return;

		const handleScroll = () => {
			if (rafCloseRef.current) return;
			rafCloseRef.current = requestAnimationFrame(() => {
				rafCloseRef.current = null;
				closeMenu();
			});
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => {
			window.removeEventListener('scroll', handleScroll);
			if (rafCloseRef.current) {
				cancelAnimationFrame(rafCloseRef.current);
				rafCloseRef.current = null;
			}
		};
	}, [openMenuToggled, closeMenu]);

	const [searchOpen, setSearchOpen] = useState(false);
	const searchInputRef = useRef(null);
	const toggleSearch = useCallback(() => {
		setSearchOpen((prev) => !prev);
	}, []);

	useEffect(() => {
		if (searchOpen) searchInputRef.current?.focus();
	}, [searchOpen]);

	const pathname = usePathname();
	const isActive = (path) => path === pathname;

	return (
		<header id="masthead">
			<nav className="navbar">
				<button id="botaoCloseMenu" aria-label="Toggle navigation" onClick={handleClickMenu} className={ openMenuToggled ? 'navbar-toggler collapsed' : 'navbar-toggler'}>
					<div className="linhasmr">
						<span className="b1"></span>
						<span className="b2"></span>
						<span className="b3"></span>
					</div>
				</button>
				<div className="navbar-brand">
					<LogoLink />
				</div>
				<div id="mobile-nav" className={ openMenuToggled ? 'show' : ''}>
					<div className='mobile-open d-lg-none'>
						<button id="botaoCloseMenu" aria-label="Toggle navigation" onClick={handleClickMenu} className={ openMenuToggled ? 'navbar-toggler collapsed' : 'navbar-toggler'}>
							<div className="linhasmr">
								<span className="b1"></span>
								<span className="b2"></span>
								<span className="b3"></span>
							</div>
						</button>
						<div className="navbar-brand">
							<LogoLink />
						</div>
						<div className="barras-search"></div>
					</div>
					<ul id="menu-principal" className="navbar-nav">
						{NavLinks.map((link) => {
							return (
								<li key={link.path} onClick={handleClickMenu}>
									<a href={link.path} className={isActive(link.path) ? 'nav-link active' : 'nav-link'} >
										{link.name}
									</a>
								</li>
							);
						})}
					</ul>
				</div>
				<div className="barras-search">
					<button
						type="button"
						className="nav-search-toggle"
						aria-label={searchOpen ? 'Fechar busca' : 'Abrir busca'}
						aria-expanded={searchOpen}
						aria-controls="nav-search"
						onClick={toggleSearch}
					>
						<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
							{searchOpen ? (
								<path d="M6 6l12 12M18 6L6 18" />
							) : (
								<>
									<circle cx="11" cy="11" r="7" />
									<path d="M16.5 16.5L21 21" />
								</>
							)}
						</svg>
					</button>
				</div>
			</nav>
			{/* GET simples: funciona sem JS e a página de resultados é cacheável. */}
			<form
				id="nav-search"
				className={searchOpen ? 'nav-search show' : 'nav-search'}
				action="/busca/"
				method="get"
				role="search"
			>
				<input
					ref={searchInputRef}
					type="search"
					name="q"
					placeholder="Buscar no TV Foco"
					aria-label="Buscar notícias"
					autoComplete="off"
					required
				/>
				<button type="submit">Buscar</button>
			</form>
			<div id="overlayMenu" className={ openMenuToggled ? 'show' : ''}></div>
		</header>
	);
};

export default Navbar;